import { SelectOptions } from '@etoh/database/core';

export type SampleShipmentTemplateName =
  | 'globalWithSupplier'
  | 'globalWithoutSupplier'
  | 'australiaPacking'
  | 'australiaTasting';

export type SampleShipmentCarrier =
  | 'cochranesTransport'
  | 'fleurieuLogistics'
  | 'busFreight';

export const SampleshipmentCarriersOptions: SelectOptions<SampleShipmentCarrier>[] =
  [
    { value: 'cochranesTransport', label: 'Cochranes transport' },
    { value: 'fleurieuLogistics', label: 'Fleurieu logistics' },
    { value: 'busFreight', label: 'Bus Freight' },
  ];
